import { MappingProfile } from '@automapper/core';
import { createMetadataForFiltersOptions, createMetadataForMasterUnits } from '../filters-options/filters-options-metadata';
import { mapOpDataFiltersOptions } from '../filters-options/filters-options-mapping';

export const opDataFiltersOptionsProfile: MappingProfile = (mapper) => {
    createMetadataForMasterUnits();
    createMetadataForFiltersOptions();
    mapOpDataFiltersOptions(mapper);
};
